export default __webpack_public_path__ + "static/media/time.9bd4b7ad.svg";